import classNames from "classnames";
import { AnimatePresence, motion } from "framer-motion";
import { ReactNode } from "react";

type PropsType = {
  isOpen: boolean;
  onCancel?: () => void;
  widthSize?: string;
  children: ReactNode;
  containerClassName?: string;
  contentClassName?: string;
  style?: React.CSSProperties;
};

const Modal: React.FC<PropsType> = ({
  onCancel,
  isOpen,
  children,
  widthSize,
  containerClassName,
  contentClassName,
  style,
}) => {
  const backdropVariants = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 },
  };

  const modalVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.4 } },
  };

  return (
    <>
      <AnimatePresence>
        {isOpen && (
          <>
            <motion.div
              key="backdrop"
              variants={backdropVariants}
              initial="hidden"
              animate="visible"
              exit="hidden"
              className={classNames(
                "block fixed bg-black/60  w-[100%] h-[100vh] top-0 left-0 opacity-95 z-[100]",
                containerClassName
              )}
              onClick={onCancel}
            />
            <motion.div
              key="modal"
              variants={modalVariants}
              initial="hidden"
              animate="visible"
              exit="hidden"
              style={style}
              className={classNames(
                `font-outfit fixed bg-white top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  w-[90%] ${
                  widthSize ? widthSize : "md:w-[740px]"
                }   opacity-100 leading-[127%] flex flex-col z-[101] shadow-lg rounded-[24px]`,
                contentClassName
                  ? contentClassName
                  : "max-h-[90%] overflow-scroll "
              )}
              onClick={(e) => e.stopPropagation()}
            >
              {children}
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default Modal;
